
import { DEFAULT_PRINTER_URL } from '../../../../Model/PrinterFunction';

export default class PrinterManagerHelper {
    static printerManagerUpdateAudioSetting = (setting = {}) => {
        $.ajax({
            url: `${DEFAULT_PRINTER_URL}/update_audio_setting`,
            type: "POST",
            crossDomain: true,
            data : {
                audio_setting: setting,
            },
            success: (response) => {
                console.log(response)
            }
        })
    }
}